// extracted by mini-css-extract-plugin
export default {"section":"Help_section__Dg5Cz","block":"Help_block__1NIpb","help":"Help_help__4manY"};